import script from "./itemDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./itemDetail.vue?vue&type=script&setup=true&lang=js"

import "./itemDetail.vue?vue&type=style&index=0&id=018f9204&scoped=true&lang=scss"
import "./itemDetail.vue?vue&type=style&index=1&id=018f9204&lang=scss"

import exportComponent from "/home/lw8dl1214/actions-runner/_work/AIPR-Frontend/AIPR-Frontend/haleon-ar-detector/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-018f9204"]])

export default __exports__